var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPipIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 4C28.3539 4 28.6931 4.14048 28.9431 4.39052C29.1932 4.64057 29.3337 4.97971 29.3337 5.33333V14.6667H26.667V6.66667H5.33366V25.3333H13.3337V28H4.00033C3.6467 28 3.30756 27.8595 3.05752 27.6095C2.80747 27.3594 2.66699 27.0203 2.66699 26.6667V5.33333C2.66699 4.97971 2.80747 4.64057 3.05752 4.39052C3.30756 4.14048 3.6467 4 4.00033 4H28.0003ZM28.0003 17.3333C28.3539 17.3333 28.6931 17.4738 28.9431 17.7239C29.1932 17.9739 29.3337 18.313 29.3337 18.6667V26.6667C29.3337 27.0203 29.1932 27.3594 28.9431 27.6095C28.6931 27.8595 28.3539 28 28.0003 28H17.3337C16.98 28 16.6409 27.8595 16.3909 27.6095C16.1408 27.3594 16.0003 27.0203 16.0003 26.6667V18.6667C16.0003 18.313 16.1408 17.9739 16.3909 17.7239C16.6409 17.4738 16.98 17.3333 17.3337 17.3333H28.0003ZM8.94299 8.39067L11.943 11.3907L14.667 8.66667V16H7.33366L10.0577 13.276L7.05766 10.276L8.94299 8.39067Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPipIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pip-icon.f456226a.svg";
export { ForwardRef as ReactComponent };